import { Baby } from 'lucide-react';
import type { ReactElement } from 'react';
import { Outlet } from 'react-router';

import styles from './AuthLayout.module.css';

export function AuthLayout(): ReactElement {
    return (
        <div className={styles.layout}>
            <div className={styles.card}>
                <div className={styles.brand}>
                    <Baby size={22} aria-hidden="true" />
                    <span>Little Possum</span>
                </div>
                <Outlet />
            </div>
        </div>
    );
}
